"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "table-row" };
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "booking-color bg-bhp" }, null, -1);
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, "2022.11.30. 15:30", -1);
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, "AB CD 102", -1);
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, "Mercedes Benz CLA", -1);
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, "1. SZGK állás", -1);
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", { class: "long" }, "komlett kerék csere hozott kerekekkel", -1);
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, "16 000 Ft", -1);
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "#" }, "HBHP-23-99999")
], -1);
const CalendarFooterItems_vue_1 = __importDefault(require("../footer/CalendarFooterItems.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TableRow',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_1, [
                (0, vue_2.createElementVNode)("td", null, [
                    _hoisted_2,
                    (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                        icon: true,
                        text: "Nyitott"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                class: "fontawsome-icon text-orange",
                                icon: "fa-solid fa-circle-exclamation"
                            })
                        ]),
                        _: 1
                    })
                ]),
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                        class: "text-bhp text-6xl",
                        icon: ['far', 'square-check']
                    })
                ]),
                (0, vue_2.createElementVNode)("td", null, [
                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                        class: "text-marso text-6xl",
                        icon: ['far', 'rectangle-xmark']
                    })
                ])
            ]));
        };
    }
});
